<template>
  <b-modal
    :visible="visible"
    hide-footer
    button-size="sm"
    modal-cancel="false"
    no-close-on-backdrop
    @close="close"
    size="sm"
    id="confirm-programming-modal"
  >
    <template v-slot:modal-title>Confirmar programación</template>
    <div class="container-fluid">
      <ValidationObserver ref="form" v-slot="{ invalid }">
        <form @submit.prevent="edit">
          <section class="row">
            <div class="col">
              <p>
                El estudiante no aprobó el curso
                <b>{{ lastCourse.course_name }}</b
                >, si desea continuar con la programación escriba
                <b>PROGRAMAR</b> en el campo de texto.
              </p>
            </div>
          </section>
          <section class="row">
            <!-- Confirmar programación -->
            <div class="col">
              <div class="form-group">
                <ValidationProvider
                  name="confirm_text"
                  rules="required|is:PROGRAMAR"
                  v-slot="{ valid, errors }"
                >
                  <label class="control-label" for="confirm_text"
                    >Texto de confirmación
                  </label>
                  <input
                    type="text"
                    v-model="confirm_text"
                    class="form-control form-control-sm"
                    id="confirm_text"
                  />
                  <b-form-invalid-feedback :state="valid">{{
                    errors[0]
                  }}</b-form-invalid-feedback>
                </ValidationProvider>
              </div>
            </div>
          </section>
          <hr />
          <b-button type="button" size="sm" variant="danger" @click="close">
            <CIcon size="sm" name="cil-x-circle" /> Cancelar
          </b-button>
          <button
            type="submit"
            class="btn btn-success btn-sm float-right"
            variant="success"
            :disabled="invalid"
          >
            <span> <CIcon size="sm" name="cil-save" /> Confirmar </span>
          </button>
        </form>
      </ValidationObserver>
    </div>
  </b-modal>
</template>
<script>
import { BFormInvalidFeedback, BModal, BButton } from "bootstrap-vue";
import { extend } from "vee-validate";
import { required, is } from "vee-validate/dist/rules";

export default {
  name: "ConfirmProgrammingModal",
  components: {
    BFormInvalidFeedback,
    BModal,
    BButton,
  },
  props: {
    modalShowConfirmProgramming: { type: Boolean, required: true },
    lastCourse: { required: true },
  },
  data() {
    return {
      dataEmit: { modalShow: false, data: null, status: 200 },
      confirm_text: "",
    };
  },
  created() {
    extend("required", {
      ...required,
      message: "Este campo es requerido",
    });
    extend("is", {
      ...is,
      message: "Este campo es no coincide con la palabra PROGRAMAR",
    });
  },

  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
    visible() {
      return this.modalShowConfirmProgramming;
    },
  },
  methods: {
    edit() {
      this.closeModal({ confirm: true });
    },
    closeModal(data = null, status = 200) {
      this.dataEmit.modalShow = false;
      this.dataEmit.data = data;
      this.dataEmit.status = status;
      this.$emit("confirmProgramming", this.dataEmit);
    },
    close() {
      this.closeModal();
    },
  },
};
</script>
